import { NextPageContext } from 'next';
import { KnownCookie } from '@sls-react/typings/cookies';
import { CookieSerializeOptions } from 'cookie';
import { destroyCookie, setCookie } from 'nookies';

export default function universalSetCookie(
  ctx: NextPageContext | null | undefined,
  name: KnownCookie | string,
  value: any,
  options: CookieSerializeOptions = { path: '/', maxAge: 31557600 },
): void {
  if (value == null) {
    destroyCookie(ctx, name, options);
    if (ctx?.req?.['cookies']) {
      ctx.req['cookies'][name] = undefined;
    }
  } else {
    setCookie(ctx, name, value, options);
    if (ctx?.req?.['cookies']) {
      ctx.req['cookies'][name] = value;
    }
  }
}
